var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Essentional, UI / Menu Dots "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 7.5C4.375 8.19036 3.81536 8.75 3.125 8.75C2.43464 8.75 1.875 8.19036 1.875 7.5C1.875 6.80964 2.43464 6.25 3.125 6.25C3.81536 6.25 4.375 6.80964 4.375 7.5Z",
    fill: "#4B4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.5C8.75 8.19036 8.19036 8.75 7.5 8.75C6.80964 8.75 6.25 8.19036 6.25 7.5C6.25 6.80964 6.80964 6.25 7.5 6.25C8.19036 6.25 8.75 6.80964 8.75 7.5Z",
    fill: "#4B4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.5C13.125 8.19036 12.5654 8.75 11.875 8.75C11.1846 8.75 10.625 8.19036 10.625 7.5C10.625 6.80964 11.1846 6.25 11.875 6.25C12.5654 6.25 13.125 6.80964 13.125 7.5Z",
    fill: "#4B4B4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.fe70a1a4b66f8533606a42ed5ce0f69e.svg";
export { ForwardRef as ReactComponent };